<template>
	<div class="grid gap-4">
		<FormKit type="text" name="description" label="Omschrijving" />
		<FormKit
			type="loanlinkCurrency"
			name="monthlyDeposit"
			label="Gemiddelde inleg per maand"
		/>
		<FormKit
			type="loanlinkCurrency"
			name="currentBalance"
			label="Actueel saldo"
		/>
	</div>
</template>
